module.exports = __webpack_public_path__ + "img/shield-lock-fill.6caf07f3.svg";